module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/date-940ea41a62a282bae8d660072faf8452.svg";